import React from 'react';

interface Props {
  icon: string;
  className: string;
}

function Icon({ icon, className }: Props) {
  return <img src={icon} className={className} />;
}

export default Icon;
